export default __webpack_public_path__ + "static/media/photo--lg--daniel-1.9e7c97c1.jpg";